import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

const SubmissionsPage = () => {
  const { quizId } = useParams();
  const [submissions, setSubmissions] = useState([]);
  useEffect(() => {
    if (!quizId) return;
    api.get(`/submissions/${quizId}/ungraded`)
      .then(res => setSubmissions(res.data.submissions || []))
      .catch(console.error);
  }, [quizId]);

  return (
    <div className="p-6">
      <h2 className="text-2xl mb-4">Submissions for Quiz {quizId}</h2>
      {submissions.length === 0 && <p>No submissions to grade.</p>}
      <ul className="list-disc pl-5">
        {submissions.map(s => (
          <li key={s.id}>Submission #{s.id} - Student ID {s.userId} - Score: {s.score}</li>
        ))}
      </ul>
    </div>
  );
};

export default SubmissionsPage;
